export const CDN_PATH = 'https://cdn.creditcardswitch.fino.digital';
export const CDN_MPATH = 'https://fino-tenant-assets.s3.amazonaws.com';
